(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sample-list"] && !Shopify.designMode) return;
  try {
    
  let $j = jQuery.noConflict();
  $j(document).ready(function(){
    $j('.zw-stof-section .zw-container .zw-stof-products-container .zw-stof-block .zw-img-container').click((e)=>{
      let product_id = e.target.closest('.zw-img-container').getAttribute("id");
      if(e.target.closest('.zw-img-container').classList.contains('selected')){
        delete_product_from_list(product_id.split("-")[1]);
      }
      else{
        let counter= $j('.zw-color-swatches-section .zw-selected-block').attr("select").split(",");
        if(counter.length > 0 && counter[0] != ''){
        $j(`#${product_id}`).addClass('selected');
        $j.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: product_id.split("-")[1]
        },
          dataType: 'json', 
         success: function (item) {
           let counter= $j('.zw-color-swatches-section .zw-selected-block').attr("select").split(",");
            add_product_from_list(item,counter);

           const bottomListElement = document.querySelector('.zw-color-swatches-section');
           bottomListElement.classList.remove('empty');
         }
        }); 
      }
        else
        {
          // alert("You have been passed the limit");
          // Swal.fire({
          //   title: '🔥 Warnung',
          //   text: 'Sie haben das Limit überschritten',
          //   icon: 'warning',
          //   confirmButtonText: 'OK'
          // });

        }
      }
    });
        function add_product_from_list(item,counter){
          let position = counter.shift();
          $j(`#item-${item.id}`).addClass('selected');
          let content = `<div class="zw-img-container"><button type="button" class="btn zw-close">&times;</button>
          <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" loading="lazy"></div>
          <div class="zw-stof-name">${item.title}</div>`;
          
          $j(`.zw-color-swatches-section .zw-stof-block[counter="${position}"]`).html(content);
          $j(`.zw-color-swatches-section .zw-stof-block[counter="${position}"] .zw-img-container`).attr("id",`swatch-${item.id}`);
          $j('.zw-color-swatches-section .zw-selected-block').attr("select",counter.join(','));
          $j(`#swatch-${item.id} button.btn.zw-close`).click((btn)=>{
            delete_product_from_list(item.id);
          });
        }
    
        function delete_product_from_list(id){
        $j(`#item-${id}`).removeClass('zw-img-container selected').addClass('zw-img-container');
        $j.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              quantity: 0,
              id: id
            },
              dataType: 'json', 
             success: function (data) {
               
               let counter=$j('.zw-color-swatches-section .zw-selected-block').attr("select").split(",");
               let swatch_node = `#swatch-${id}`;
               let node_position =$j(swatch_node).parent().attr("counter");
                $j(swatch_node).next('.zw-stof-name').remove();
                $j(swatch_node).empty();
                $j(swatch_node).removeAttr("id");
               counter.push(node_position);
               if(counter.length > 0 && counter[0] != ''){
                 counter.sort();
                 value = counter.join(",");
               }
               else{
                 value=node_position;
               }
               
               $j('.zw-color-swatches-section .zw-selected-block').attr("select",value);
               if(counter.length == 6){
                 $j('.zw-color-swatches-section').addClass('empty');
               }
             }
          });
      }
    const sampleProductInfoIcons = document.querySelectorAll('.zw-stof-section .zw-stof-products-container .icon');
    if (sampleProductInfoIcons) {
      sampleProductInfoIcons.forEach(icon => {
        if (window.innerWidth <= 576){
          icon.addEventListener('click', () => {
            let target_node = icon.closest('.zw-stof-block');
            if (target_node.classList.contains("active")) {
                target_node.classList.remove("active");
            } else {
              document.querySelector('.zw-stof-section .zw-stof-products-container .zw-stof-block.active')?.classList.remove("active");
              target_node.classList.add("active");
            }
              // icon.closest('.zw-stof-block').classList.toggle("active");
          });
        }
        else{
           icon.addEventListener('mouseenter', () => {
              icon.closest('.zw-stof-block').classList.add('active');
          });
          icon.addEventListener('mouseleave', () => {
              icon.closest('.zw-stof-block').classList.remove('active');
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bottom-cart"] && !Shopify.designMode) return;
  try {
    
  let sample_list =[];
  let $j = jQuery.noConflict();
  let counter =$j('.zw-color-swatches-section .zw-selected-block').attr("select").split(",");
  $j(document).ready(function(){
    $j.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          let items= cart.items;

          const bottomListElement = document.querySelector('.zw-color-swatches-section');

          // if(items.lenght> 0){
          //   bottomListElement.classList.remove('empty');
          // }else{
          //   bottomListElement.classList.add('empty');
          // }
          
          items.forEach(item=>{
            if(item.product_type == 'sample'){
              bottomListElement.classList.remove('empty');
              
                let counter= $j('.zw-color-swatches-section .zw-selected-block').attr("select").split(",");
                add_product_from_list(item,counter);
            }
            else
            {
              console.log('not in list');
            }
          });
        }
    });
    
    function add_product_from_list(item,counter){
          let position = counter.shift();
          $j(`#item-${item.id}`).addClass('selected');
          let content = `<div class="zw-img-container"><button type="button" class="btn zw-close">&times;</button>
          <img src="${item.featured_image.url}" alt="${item.featured_image.alt}"></div>
          <div class="zw-stof-name">${item.title}</div>`;
          
          $j(`.zw-color-swatches-section .zw-stof-block[counter="${position}"]`).html(content);
          $j(`.zw-color-swatches-section .zw-stof-block[counter="${position}"] .zw-img-container`).attr("id",`swatch-${item.id}`);
          $j('.zw-color-swatches-section .zw-selected-block').attr("select",counter.join(','));
          $j(`#swatch-${item.id} button.btn.zw-close`).click((btn)=>{
            delete_product_from_list(item.id);
          });
        }
    
    function delete_product_from_list(id){
      $j(`#item-${id}`).removeClass('zw-img-container selected').addClass('zw-img-container');
      $j.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: id
          },
            dataType: 'json', 
           success: function (data) {
             
             let counter=$j('.zw-color-swatches-section .zw-selected-block').attr("select").split(",");
             let swatch_node = `#swatch-${id}`;
             let node_position =$j(swatch_node).parent().attr("counter");
              $j(swatch_node).next('.zw-stof-name').remove();
              $j(swatch_node).empty();
              $j(swatch_node).removeAttr("id");
             counter.push(node_position);
             if(counter.length > 0 && counter[0] != ''){
               counter.sort();
               value = counter.join(",");
             }
             else{
               value=node_position;
             }
             $j('.zw-color-swatches-section .zw-selected-block').attr("select",value);
             if(counter.length == 6){
                 $j('.zw-color-swatches-section').addClass('empty');
               }
           }
        });
    }
        let cart_drawer_opener = document.querySelector('.cart-drawer-opener');
    cart_drawer_opener.addEventListener('click', async(e)=>{
      e.preventDefault();
      await refreshCartDrawer();
    });
    async function refreshCartDrawer() {
      const response = await fetch('/cart?sections=cart-drawer,cart-icon-bubble');
      const sections = await response.json();


      document.querySelector('cart-drawer').classList.remove('is-empty');
      // Replace drawer HTML manually
      document.querySelector('#CartDrawer').innerHTML =
        new DOMParser().parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer').innerHTML;

      console.log(new DOMParser().parseFromString(sections['cart-drawer'], 'text/html'));
      // Replace bubble HTML manually
      document.querySelector('#cart-icon-bubble').innerHTML =
        new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html')
          .querySelector('#shopify-section-cart-icon-bubble').innerHTML;

      // Open drawer after refresh
      document.querySelector('cart-drawer').open();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
